<template>
  <div class="content-container mt-small">
    <title-with-breadcrumbs
      title="Profile"
      class="mb-regular"
    ></title-with-breadcrumbs>
    <div class="flex">
      <div>
        <div class="menu-container">
          <span class="menu-item" @click="itemActive('')">Profile</span>
          <span class="menu-item" @click="itemActive('orders')">{{
            "profile.menu.orders" | translate
          }}</span>
          <span class="menu-item" @click="itemActive('info')">{{
            "profile.menu.info" | translate
          }}</span>
          <span class="menu-item" @click="itemActive('addresses')">
            {{ "profile.menu.addresses" | translate }}
          </span>
          <span class="menu-item" @click="itemActive('newsletter')">
            {{ "profile.menu.newsletter" | translate }}
          </span>
          <span class="menu-item" @click="logoutClicked">
            {{ "profile.logout" | translate }}
          </span>
        </div>
      </div>
      <profile-orders
        v-if="active === 'orders'"
        :user="getUser"
        :orders="orders"
      ></profile-orders>
      <profile-info v-if="active === 'info'" :user="getUser"></profile-info>
      <profile-addresses
        v-if="active === 'addresses'"
        :user="getUser"
      ></profile-addresses>
      <profile-newsletter
        v-if="active === 'newsletter'"
        :user="getUser"
      ></profile-newsletter>
    </div>
  </div>
</template>

<script>
import TitleWithBreadcrumbs from "../components/atoms/title-with-breadcrumbs.vue";
import ProfileAddresses from "../components/organisms/profile-addresses.vue";
import ProfileInfo from "../components/organisms/profile-info.vue";
import ProfileNewsletter from "../components/organisms/profile-newsletter.vue";
import profileOrders from "../components/organisms/profile-orders.vue";
import { userMixin, authMixin } from "../mixins";
import {
  getStripeAccount,
  createStripeAccountLink,
  confirmStripeConnect,
  getOrdersForUser
} from "../services/api";
export default {
  components: {
    profileOrders,
    ProfileInfo,
    ProfileAddresses,
    ProfileNewsletter,
    TitleWithBreadcrumbs
  },
  name: "Register",
  mixins: [userMixin, authMixin],
  data() {
    return {
      stripeAccount: null,
      stripeAccountLink: null,
      connectSuccess: null,
      orders: null,
      active: ""
    };
  },
  methods: {
    logoutClicked() {
      this.logout();
      this.$router.push({ name: "Home" });
      this.$bvToast.toast("Logged out succesfully", {
        title: "Success",
        autoHideDelay: 5000,
        variant: "success"
      });
    },
    async getData() {
      this.stripeAccount = await getStripeAccount();
      this.stripeAccountLink = await createStripeAccountLink();
    },
    async getStripeAccountForUser() {
      const result = await getStripeAccount();
      if (result.status == 200) {
        this.stripeAccount = result.data;
      } else {
        // console.log("Account retrieval failed");
      }
    },
    async createStripeAccountLinkForUser() {
      const result = await createStripeAccountLink();
      if (result.status == 201) {
        this.stripeAccountLink = result.data.url;
      } else {
        // console.log("Link creation failed");
      }
    },
    async confirmStripeConnectForUser() {
      const result = await confirmStripeConnect();
      if (result.status == 200) {
        this.connectSuccess = result.data;
      } else {
        // console.log("Couldn't verify Stripe Connect onboarding success");
      }
    },
    itemActive(item) {
      this.active = item;
    },
    async getOrders() {
      const result = await getOrdersForUser();
      if (result.status == 200) {
        this.orders = result.data;
      } else {
        this.orders = [];
      }
    }
  },
  async beforeMount() {
    if (this.$route.query.connectReturn) {
      // console.log("Checking for success");
      await this.confirmStripeConnectForUser();
      if (this.connectSuccess != null && !this.connectSuccess) {
        // console.log("Connect Onboarding was not a success");
        await this.createStripeAccountLinkForUser();
      }
    }
    await this.getOrders();
    await this.getStripeAccountForUser();
    if (!(this.stripeAccount && this.stripeAccount.details_submitted)) {
      await this.createStripeAccountLinkForUser();
    }
    if (this.$route.query.connectRefresh) {
      if (!this.stripeAccountLink) {
        await this.createStripeAccountLinkForUser();
      }
      // console.log("Refreshing");
      window.location.href = this.stripeAccountLink;
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";
.menu-container {
  width: 10rem;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
  position: relative;
  display: flex;
  flex-direction: column;

  span {
    padding: 0.5rem 0;
  }

  .menu-item {
    transition: all 0.3s ease-in-out;
    font-weight: 500;
    position: relative;
    display: flex;
    justify-content: space-between;

    &:hover {
      transform: translate(1rem, 0px);
      font-weight: 700;
    }

    &.selected {
      font-weight: 700;

      &::after {
        content: "";
        height: 2px;
        background-color: $brand-black;
        position: absolute;
        bottom: 0;
        width: 100%;
        left: 0;
      }

      &:hover {
        transform: none;
      }
    }
  }
}

.profile-container {
  padding-left: 2rem;
}
</style>
